<template >
    <img  class="w-100 h-100" style="object-fit: contain;" src="@/assets/MGAssets/logo.svg" alt="">
</template>
<script>
export default {
    name: 'LogoComponent'
}
</script>
<style scoped>
    .logo {
        width: 80px;
    }

</style>